import React, { useState, useEffect, useContext } from "react";
import { Modal, Tab, Nav, Button, Form, Table } from "react-bootstrap";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import { precision_list_json } from "../constants";
import FeeModal from "../Convert/FeeModal";
import InfoPopUp from "../../Common/InfoPopUp";
import { OptionDataContenxt } from "./OptionChartDashboard";
import FeeModalFutureOption from "../Futures/FeeModalFuture";
import ActionButton from "../../Common/ActionButton";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import { Box, Typography } from "@mui/material";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import InfoIcon from "@mui/icons-material/Info";

const CurrencyForOptions = ["BTC", "ETH", "USDT"];

const OptionBottomTable = () => {
  const {
    assetpair,
    currencycode,
    basecurrency,
    setUpdateBalance,
    updateBalance,
    refresh,
  } = useContext(OptionDataContenxt);
  const { btncolor } = useSelector((state) => state);
  const themeColors = "Dark";
  const theme = localStorage.getItem("theme");
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("ALL");
  const [activeTab, setActivetab] = useState("hist");
  const [show, setShow] = useState(false);
  const [showFeesInfo, setShowFeesInfo] = useState(false);
  const [showFees, setShowFees] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteOpen, setShowDeleteOpen] = useState(false);
  const [showModify, setShowModify] = useState(false);
  const [showModifyStop, setShowModifyStop] = useState(false);

  const [selectedCounterBuySellTxn, setSelectedCounterBuySellTxn] =
    useState(null);
  const [selectedCounterType, setSelectedCounterType] = useState("");
  const [showTradeClose, setShowTradeClose] = useState(false);

  const userId = localStorage.getItem("userId");
  const accessToken = localStorage.getItem("access_token");

  const [myTradeTableAllPairs, setMyTradeTableAllPairs] = useState(false); // Assuming this state is coming from somewhere
  const [loader, setLoader] = useState(true);
  const [spotMyTradeData, setSpotMyTradeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tradeHistory, setTradeHistory] = useState([]);
  const [noData, setNoData] = useState(true);
  const [myTradeTableDisplayStatus, setMyTradeTableDisplayStatus] = useState(0);
  const [spotMyOfferData, setSpotMyOfferData] = useState([]);

  const [selectedBuyingAssetText, setSelectedBuyingAssetText] = useState("BTC"); // Example value, replace with your actual state value
  const [selectedSellingAssetText, setSelectedSellingAssetText] =
    useState("USDT");
  const [tradeOfferById, setTradeOfferById] = useState([]);

  const [filterMyOfferStatus, setFilterMyOfferStatus] = useState("ALL");
  const [tradeOfferByIdBuy, setTradeOfferByIdBuy] = useState([]);
  const [tradeOfferByIdSell, setTradeOfferByIdSell] = useState([]);

  const [myOfferTableAllPairs, setMyOfferTableAllPairs] = useState(false);
  const [tradeOfferByIdNewData, setTradeOfferByIdNewData] = useState([]);

  const [buySellDivStatus, setBuySellDivStatus] = useState("");

  const [buyDataNew, setBuyDataNew] = useState([]);
  const [myStopLimitAllPairs, setMyStopLimitAllPairs] = useState(true);

  const [offerData, setOfferData] = useState(null);
  const [modifyAmount, setModifyAmount] = useState("");
  const [modifyPrice, setModifyPrice] = useState("");
  const [modifyVolume, setModifyVolume] = useState("");
  const [modifyType, setModifyType] = useState("");
  const [tabModifyAmount, setTabModifyAmount] = useState("");
  const [tabModifyPrice, setTabModifyPrice] = useState("");
  const [tabModifyVolume, setTabModifyVolume] = useState("");
  const [tabModifyMarginType, setTabModifyMarginType] = useState("");
  const [manageOfferId, setManageOfferId] = useState(null);
  const [backupData, setBackupData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [delOfferId, setDelOfferId] = useState(null);
  const [delTxnType, setDelTxnType] = useState(null);
  const [delOfferType, setDelOfferType] = useState(null);
  const [delPrice, setDelPrice] = useState(null);
  const [delbal, setDelbal] = useState(null);
  const [delLaverage, setDelLaverage] = useState(null);
  const [delMarginType, setDelMarginType] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [buyData, setBuyData] = useState([]);
  const [sellData, setSellData] = useState([]);
  const [assetData, setAssetPait] = useState("");

  const [exchangeFees, setExchangeFees] = useState(null);
  const [userExchangeFee, setUserExchangeFee] = useState({
    totalVolume: 0,
    totalFees: 0,
    totalIntAccrued: 0,
    totalIntEarned: 0,
  });

  const [tabKey, setTabKey] = useState("amountUpdate");
  const tradep = 6;
  const tradem = 6;

  const [modifySlAmount, setModifySlAmount] = useState("");
  const [modifySlPrice, setModifySlPrice] = useState("");
  const [modifySlTrigger, setModifySlTrigger] = useState("");
  const [modifySlOffer, setModifySlOffer] = useState(null);
  const [flag, setFlag] = useState(null);
  const [tradePrice, setTradePrice] = useState(0);
  const [isStopLimitModifyEnable, setIsStopLimitModifyEnable] = useState(false);
  const [marginstoplimitprice, setMarginStopLimitPrice] = useState(0);
  const [marginTriggerPrice, setMarginTriggerPrice] = useState(0);
  const [marginSellstoplimitprice, setMarginSellStopLimitPrice] = useState(0);
  const [marginSellTriggerPrice, setMarginSellTriggerPrice] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [balance, setBalances] = useState();
  const storedAmount = localStorage.getItem("amountprc");
  const amountprc =
    storedAmount !== null &&
    storedAmount !== "null" &&
    storedAmount !== undefined
      ? storedAmount
      : 6;
  const [
    selectedCounterCurrencyPrecision,
    setSelectedCounterCurrencyPrecision,
  ] = useState(null);
  const [selectedBaseCurrencyPrecision, setSelectedBaseCurrencyPrecision] =
    useState(null);

  const handleClose = () => setShow(false);
  const handleCloseFees = () => setShowFees(false);
  const handleCloseFeesInfo = () => setShowFeesInfo(false);
  const handleTradeClose = () => setShowTradeClose(false);
  const handleCloseDelete = () => setShowDelete(false);
  const handleCloseDeleteOpen = () => setShowDeleteOpen(false);
  const handleCloseModify = () => setShowModify(false);
  const handleCloseModifyStop = () => setShowModifyStop(false);

  const handleButtonClick = (button) => {
    setActiveButton(button);
    handleAllButtonClickForMyTrades();
    handleTradeDisplay(button);
  };

  const modalContentMap = {
    hist: {
      title: "TRADE HISTORY",
      description: "Trade History shows all successful BUY and SELL trades.",
    },
    open: {
      title: "OPEN ORDERS",
      description:
        "Open Orders shows all BUY and SELL Offers waiting to be executed.",
    },
    stop: {
      title: "STOP-LIMIT",
      description:
        "Stop Orders shows all BUY and SELL offers created using STOP LIMIT",
    },
  };

  const currentContent = modalContentMap[activeTab];
  useEffect(() => {
    getFeesData();
  }, []);

  useEffect(() => {
    const buyingCryptoAsset = currencycode?.toUpperCase();
    const sellingCryptoAsset = basecurrency?.toUpperCase();

    if (buyingCryptoAsset && sellingCryptoAsset) {
      setSelectedCounterCurrencyPrecision(
        getSpecificCurrencyPrecision(buyingCryptoAsset)
      );
      setSelectedBaseCurrencyPrecision(
        getSpecificCurrencyPrecision(sellingCryptoAsset)
      );
    }
  }, [basecurrency]);

  useEffect(() => {
    setActivetab(localStorage.getItem("tradeNavHistO") || "hist");
    renderDataForMyTradeSpot();
    callAllStopLimitOffers();
    renderDataForMyOfferSpot();
  }, [refresh, assetpair]);

  const renderDataForMyTradeSpot = () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    axios
      .get(
        `https://stream.paybito.com/StreamingApi/rest/getOTradeHistoryByIdRest?uuid=${uuid}&assetPair=${assetpair}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      )
      .then((response) => {
        setLoader(false);
        setSpotMyTradeData(response.data.tradeListResult);
        // document.body.classList.remove("overlay");
      })
      .catch((error) => {
        setLoader(false);
        document.body.classList.remove("overlay");
        if (error.response && error.response.data.error === "invalid_token") {
          showToast("eror", "Session Timeout. Login Again");
          //logout
        } else {
          // alert("Could Not Connect To Server", "danger");
        }
      });
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  // Function to fetch all trade pairs data
  const callMyTradeAllPairsAPI = () => {
    axios
      .get(
        `https://stream.paybito.com/StreamingApi/rest/getOptionTradeByAccountIDAll?userID=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTradeHistory(response.data.tradeListResult);
        setSpotMyTradeData(response.data.tradeListResult);
        setNoData(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        showToast("error", "Could Not Connect To Server");
      });
  };

  // Function to handle button click
  const handleAllButtonClickForMyTrades = () => {
    if (myTradeTableAllPairs) {
      callMyTradeAllPairsAPI();
    } else {
      renderDataForMyTradeSpot();
    }
  };

  const saveLastTabTradeComp = (id) => {
    localStorage.setItem("tradeNavHistO", id);
    setActivetab(id);
  };

  const handleTradeDisplay = (value) => {
    setMyTradeTableDisplayStatus(value);
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    console.log("check checkbox", isChecked);
    setMyTradeTableAllPairs(isChecked);
    setMyOfferTableAllPairs(false);

    if (isChecked) {
      callMyTradeAllPairsAPI();
    } else {
      renderDataForMyTradeSpot();
    }
  };

  const renderDataForMyOfferSpot = async () => {
    const uuid = localStorage.getItem("uuid");
    try {
      const response = await axios.get(
        `https://stream.paybito.com/StreamingApi/rest/getOOffersByAccountIDRest?uuid=${uuid}&assetPair=${assetpair}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      console.log("resposne--->", response);

      setLoader(false);
      setTradeOfferById(response?.data?.tradeListResult || []);
    } catch (error) {
      console.error(error);
      // You can also handle errors here if needed.
    }
  };

  const checkValueMyOffer = (event) => {
    const isChecked = event.target.checked;
    console.log("check checkbox", isChecked);
    setMyOfferTableAllPairs(isChecked);
    setMyTradeTableAllPairs(false);

    if (isChecked) {
      callMyOfferAllPairsAPI();
    } else {
      renderDataForMyOfferSpot();
    }
  };

  const callMyOfferAllPairsAPI = () => {
    axios
      .get(
        `https://stream.paybito.com/StreamingApi/rest/getOptionOfferByAccountIDAll?userID=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        setTradeOfferByIdNewData(data?.tradeListResult);
        setTradeOfferById(data?.tradeListResult);
        clickAllButton();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const clickAllButton = () => {
    // Implement the logic for clickAllButton here
    console.log("Click All Button Triggered");
  };

  const buySellDivChangeStatus = (status) => {
    setBuySellDivStatus(status);
  };

  const callAllStopLimitOffers = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
      assetPair: assetpair,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}optionsTrade/GetStopLossBuySell`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      const data = JSON.parse(response?.data?.apiResponse);
      console.log("datatatata", data?.stopLossList);

      setBuyDataNew(data?.stopLossList || []);
    } catch (error) {
      console.error("Error fetching stop limit offers:", error);
    }
  };

  const convertToNumber = (val) => {
    return parseFloat(val).toFixed(
      parseInt(localStorage.getItem("priceprc") || 6)
    );
  };
  const myTradeTotal = (val) => {
    return parseFloat(val).toFixed(
      parseInt(localStorage.getItem("priceprc")) || 6
    );
  };

  const dateFormat = (inputDate) => {
    // Parse the input date string into a Date object
    const date = new Date(inputDate);

    // Function to pad with zero if less than 10
    const padZero = (num) => (num < 10 ? `0${num}` : num);

    // Get the formatted date
    const formattedDate = `${padZero(date.getDate())}-${date
      .toLocaleString("en-GB", { month: "short" })
      .toUpperCase()}-${date.getFullYear()} ${padZero(
      date.getHours() % 12 || 12
    )}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())} ${
      date.getHours() >= 12 ? "PM" : "AM"
    }`;
    return formattedDate;
  };

  const getOfferDetails = (content, offerId) => {
    setLoading(true);
    setOfferData(null);
    setTabModifyAmount(0);
    setTabModifyPrice(0);
    setModifyAmount(0);
    setModifyPrice(0);
    setModifyVolume(0);
    setModifyType("");
    setTabModifyVolume(0);
    setTabModifyMarginType("");

    const inputObj = {
      offer_id: offerId,
      userId: userId,
      uuid: localStorage.getItem("uuid"),
    };

    axios
      .post(`${WEBSERVICE}optionsTrade/GetOfferByID`, inputObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        setLoading(false);
        const result = response.data;
        setBackupData(result);

        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg); // Handle error alert
        } else {
          setManageOfferId(offerId);
          const tradeResult = result.tradeResult;

          setModifyAmount(parseFloat(tradeResult.amount));
          setTabModifyAmount(parseFloat(tradeResult.amount));
          setModifyPrice(parseFloat(tradeResult.price));
          setTabModifyPrice(parseFloat(tradeResult.price));
          setTabModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyType(tradeResult.txn_type);
          setDelLaverage(tradeResult.leverage);

          setShowModify(true); // Open modal
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.error === "invalid_token") {
          // Handle session timeout
          // Handle logout logic here
          //logout
        } else {
          showToast("error", "Could Not Connect To Server"); // Handle server error
        }
      });
  };

  const getMarginOfferDetails = (content, offerId) => {
    setLoading(true);
    setOfferData(null);
    setTabModifyAmount(0);
    setTabModifyPrice(0);
    setModifyAmount(0);
    setModifyPrice(0);
    setModifyVolume(0);
    setModifyType("");
    setTabModifyVolume(0);
    setTabModifyMarginType("");

    const inputObj = {
      offer_id: offerId,
      userId: userId,
      uuid: localStorage.getItem("uuid"),
    };

    console.log("calling");

    axios
      .post(`${WEBSERVICE}optionsTrade/GetOfferByID`, inputObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        setLoading(false);
        const result = response.data;
        setBackupData(result);

        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg); // Handle error alert
        } else {
          setManageOfferId(offerId);
          const tradeResult = result.tradeResult;

          setModifyAmount(parseFloat(tradeResult.amount));
          setTabModifyAmount(parseFloat(tradeResult.amount));
          setModifyPrice(parseFloat(tradeResult.price));
          setTabModifyPrice(parseFloat(tradeResult.price));
          setTabModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyType(tradeResult.txn_type);
          setDelLaverage(tradeResult.leverage);

          if (tradeResult?.offerType === "3") {
            setTabModifyMarginType("1");
          } else if (tradeResult?.offerType === "4") {
            setTabModifyMarginType("2");
          }
          setShowModify(true); // Open modal
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.error === "invalid_token") {
          // Handle session timeout
          // Handle logout logic here
          //logout
        } else {
          showToast("error", "Could Not Connect To Server"); // Handle server error
        }
      });
  };

  const deleteTrade = (
    content,
    offerId,
    txnType,
    asset_pair,
    price,
    amount,
    margin,
    leverage
  ) => {
    setDelOfferId(offerId);
    setDelTxnType(txnType);
    setDelLaverage(leverage);
    setDelMarginType(margin);
    setAssetPait(asset_pair);
    setDelPrice(price);
    setDelbal(amount);
    setModalContent(content);
    setShowDeleteOpen(true); // Show the modal
  };

  const marginDeleteTrade = (
    content,
    offerId,
    txnType,
    price,
    amount,
    offerType
  ) => {
    setDelOfferId(offerId);
    setDelTxnType(txnType);
    setDelOfferType(offerType);
    setDelPrice(price);
    setDelbal(amount);
    setModalContent(content);
    setShowDeleteOpen(true); // Show the modal
  };

  console.log("delLaverage", delLaverage);

  const manageOfferAmount = async () => {
    //  alert("Loading...", "dark");
    try {
      let inputObj = {
        offer_id: manageOfferId,
        amount: tabModifyAmount,
        price: tabModifyPrice,
        txn_type: modifyType,
        action: "amountupdate",
        uuid: localStorage.getItem("uuid"),
        assetPair: assetpair,
        marginType: 0,
        offerType: "L",
        leverage: delLaverage,
      };

      if (modifyType === 1) {
        inputObj["selling_asset_code"] = selectedSellingAssetText.toUpperCase();
        inputObj["buying_asset_code"] = selectedBuyingAssetText.toUpperCase();
      } else {
        inputObj["buying_asset_code"] = selectedSellingAssetText.toUpperCase();
        inputObj["selling_asset_code"] = selectedBuyingAssetText.toUpperCase();
      }

      const jsonString = JSON.stringify(inputObj);

      const response = await axios.post(
        `${WEBSERVICE}optionsTrade/TradeManageOffer`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast("success", response.data.error.error_msg);
        handleCloseModify();
        setUpdateBalance(!updateBalance);
        if (localStorage.getItem("tradeNavHist") === "open") {
          renderDataForMyOfferSpot();
        } else if (localStorage.getItem("tradeNavHist") === "stop") {
          renderDataForStopLimitSpot("buy");
        } else {
          renderDataForMyTradeSpot();
        }
      }
    } catch (error) {
      if (error.response && error.response.data.error === "invalid_token") {
        alert("Session Timeout. Login Again", "warning");
        //logout
      } else {
        // alert("Could Not Connect To Server", "danger");
      }
    }
  };

  const renderDataForStopLimitSpot = async (param) => {
    let transactionType = param === "buy" ? "1" : "2";
    let uuid = localStorage.getItem("uuid");
    let buyingAsset =
      param === "buy"
        ? selectedBuyingAssetText.toUpperCase()
        : selectedSellingAssetText.toUpperCase();
    let sellingAsset =
      param === "buy"
        ? selectedSellingAssetText.toUpperCase()
        : selectedBuyingAssetText.toUpperCase();

    let payload = {
      uuid,
      buying_asset_code: buyingAsset,
      selling_asset_code: sellingAsset,
      txn_type: transactionType,
    };

    try {
      setLoader(true);
      const response = await axios.post(
        `${WEBSERVICE}userTrade/GetStopLossBuySell`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
        }
      );

      if (param === "buy") {
        setBuyData(response.data.stopLossList);
      } else {
        setSellData(response.data.stopLossList);
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        alert("Session Timeout. Login Again", "warning");
        //logout
      } else {
        alert("Could Not Connect To Server", "danger");
      }
    } finally {
      setLoader(false);
      document.body.classList.remove("overlay");
    }
  };

  const manageOfferPrice = async () => {
    try {
      // alert("Loading...", "dark");
      const uuid = localStorage.getItem("uuid");

      let inputObj = {
        offer_id: manageOfferId,
        selling_asset_code:
          modifyType === 1
            ? selectedSellingAssetText.toUpperCase()
            : selectedBuyingAssetText.toUpperCase(),
        buying_asset_code:
          modifyType === 1
            ? selectedBuyingAssetText.toUpperCase()
            : selectedSellingAssetText.toUpperCase(),
        amount: tabModifyAmount,
        price: tabModifyPrice,
        txn_type: modifyType,
        uuid,
        assetPair: assetpair,
        marginType: 0,
        offerType: "L",
        leverage: delLaverage,
      };

      const tradeManageOfferResponse = await axios.post(
        `${WEBSERVICE}optionsTrade/TradeManageOffer`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = tradeManageOfferResponse.data;
      // data.loader = false;

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        showToast("success", result.error.error_msg);
        handleCloseModify();
        setUpdateBalance(!updateBalance);
        const tradeNavHist = localStorage.getItem("tradeNavHist");
        if (tradeNavHist === "open") {
          renderDataForMyOfferSpot();
        } else if (tradeNavHist === "stop") {
          renderDataForStopLimitSpot("buy");
        } else {
          renderDataForMyTradeSpot();
        }
      }
    } catch (error) {
      if (error.response && error.response.data.error === "invalid_token") {
        alert("Session Timeout. Login Again", "warning");
        //logout
      }
    }
  };

  const getTradePrice = (m) => {
    return parseFloat(m.price).toFixed(
      parseInt(selectedCounterCurrencyPrecision)
    );
  };

  const getTradeAmount = (m) => {
    return parseFloat(m.amount).toFixed(
      parseInt(selectedCounterCurrencyPrecision)
    );
  };
  const getLiqPrice = (m) => {
    let { liqPrice, price, action } = m;
    let result = false;

    if (parseFloat(liqPrice) > 0) {
      result = true;

      if (action.toUpperCase() === "BUY") {
        result = parseFloat(liqPrice) <= parseFloat(price);
      } else {
        result = parseFloat(liqPrice) >= parseFloat(price);
      }
    }

    return result;
  };

  const handlePnlPositiveValue = (param) => {
    const pnl = param.split("(")[1]?.split("%")[0];
    console.log("pnldata", param, pnl);
    return parseFloat(pnl) >= 0;
  };
  const getStoplossAmount = (s) => parseFloat(s.quantity).toFixed(amountprc);
  const getStoplossPriceNew = (s) =>
    parseFloat(s.stop_loss_price).toFixed(tradep);
  const getStoplossTriggerPriceNew = (s) =>
    parseFloat(s.trigger_price).toFixed(tradep);

  const modifyStoploss = (id, q, p, t, flag) => {
    setModalShow(true);
    setModifySlAmount(q);
    setModifySlPrice(p);
    setModifySlTrigger(t);
    setModifySlOffer(id);
    setFlag(flag);
    setShowModifyStop(true);
  };

  const marginModifyStoploss = (id, q, p, t, tradeprice, flag) => {
    setIsStopLimitModifyEnable(false);
    setModalShow(true);
    setModifySlAmount(q);
    setModifySlPrice(p);
    setModifySlTrigger(t);
    setModifySlOffer(id);
    setTradePrice(tradeprice);
    setFlag(flag);
    setMarginStopLimitPrice(tradeprice * 0.85);
    setMarginTriggerPrice(tradeprice * 0.86);
    setMarginSellStopLimitPrice(tradeprice * 1.15);
    setMarginSellTriggerPrice(tradeprice * 1.14);
    setShowModifyStop(true);
  };

  const delStoploss = (id, q, p, t, flag) => {
    setShowDelete(true);
    setModifySlAmount(q);
    setModifySlPrice(p);
    setModifySlTrigger(t);
    setModifySlOffer(id);
    setFlag(flag);
  };

  const removeStoploss = async () => {
    const inputObj = {
      modify_type: "delete",
      stoploss_id: modifySlOffer,
      stop_loss_price: modifySlPrice,
      trigger_price: modifySlTrigger,
      quantity: modifySlAmount,
      uuid: localStorage.getItem("uuid"),
      txn_type: flag,
      selling_asset_code:
        flag === 1 ? basecurrency?.toUpperCase() : currencycode?.toUpperCase(),
      buying_asset_code:
        flag === 1 ? currencycode?.toUpperCase() : basecurrency?.toUpperCase(),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}optionsTrade/ModifyStopLossBuySell`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      // data.loader = false;
      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast("success", response.data.error.error_msg);
        setShowDelete(false);
        callAllStopLimitOffers();
        setUpdateBalance(!updateBalance);
      }
    } catch (error) {
      // data.loader = false;
      showToast("error", "Failed to delete stop loss");
    }
  };

  const manageStoploss = async () => {
    // showToast("Loading...");
    // const flag = localStorage.getItem("trade_flag")?.toLowerCase() || "buy";
    const buyingAsset = currencycode?.toUpperCase();
    const sellingAsset = basecurrency?.toUpperCase();
    const tradeServiceUrl = `https://options-socket.paybito.com/oSocketStream/api/marketPrice?symbol=${assetpair}&side=${
      flag === "buy" || flag === 1 ? "BID" : "ASK"
    }&amount=${modifySlAmount}`;

    try {
      const response = await fetch(tradeServiceUrl);
      const result = await response.json();

      if (result.statuscode !== 0) {
        const marketOrderPrice = parseFloat(result.price);
        const isBuy = flag === "buy" || flag === 1;

        // console.log(
        //   "marketOrderPrice",
        //   marketOrderPrice,
        //   "stop price",
        //   modifySlTrigger,
        //   "limit price",
        //   modifySlPrice
        // );
        if (
          ((flag === "buy" || flag === 1) &&
            marketOrderPrice < Number(modifySlTrigger) &&
            marketOrderPrice < Number(modifySlPrice) &&
            Number(modifySlTrigger) < Number(modifySlPrice)) ||
          ((flag === "sell" || flag === 2) &&
            marketOrderPrice > Number(modifySlTrigger) &&
            marketOrderPrice > Number(modifySlPrice) &&
            Number(modifySlTrigger) > Number(modifySlPrice))
        ) {
          const inputObj = {
            selling_asset_code: flag === "buy" ? sellingAsset : buyingAsset,
            buying_asset_code: flag === "buy" ? buyingAsset : sellingAsset,
            modify_type: "edit",
            stoploss_id: modifySlOffer,
            stop_loss_price: modifySlPrice,
            trigger_price: modifySlTrigger,
            quantity: modifySlAmount,
            txn_type: flag === "buy" || flag === 1 ? "1" : "2",
            uuid: localStorage.getItem("uuid"),
          };

          const response = await axios.post(
            `${WEBSERVICE}optionsTrade/ModifyStopLossBuySell`,
            inputObj,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `BEARER ${accessToken}`,
              },
            }
          );

          if (response.data.error.error_data !== 0) {
            showToast("error", response.data.error.error_msg);
          } else {
            showToast("success", response.data.error.error_msg);
            setUpdateBalance(!updateBalance);
            callAllStopLimitOffers();
            setShowModifyStop(false);
          }
        } else {
          setShowModifyStop(false);
          showToast(
            "error",
            isBuy
              ? "*Market order price should be less than stop price and limit price should be greater than stop price"
              : "*Market order price should be greater than stop price and limit price should be less than stop price"
          );
        }
      } else {
        showToast("error", "*Orderbook depth reached, price not found");
      }
    } catch (error) {
      // showToast("error", "Error processing request");
    }
  };

  const delMarginOffer = async () => {
    try {
      // setData(prev => ({ ...prev, loader: true }));

      const inputObj = {
        offer_id: delOfferId,
        uuid: localStorage.getItem("uuid"),
        amount: "0",
        txn_type: delTxnType,
        price: delPrice,
        offerType: "D",
        marginType: delOfferType,
        assetCode: localStorage.getItem("assetCode"),
      };

      if (delTxnType === 2) {
        inputObj.selling_asset_code = selectedBuyingAssetText.toUpperCase();
        inputObj.buying_asset_code = selectedSellingAssetText.toUpperCase();
      }
      if (delTxnType === 1) {
        inputObj.selling_asset_code = selectedSellingAssetText.toUpperCase();
        inputObj.buying_asset_code = selectedBuyingAssetText.toUpperCase();
      }

      const headers = {
        "Content-Type": "application/json",
        authorization: "BEARER " + accessToken,
      };

      const response = await axios.post(
        `${WEBSERVICE}margin/manageOffer`,
        inputObj,
        { headers }
      );

      // setData(prev => ({ ...prev, loader: false }));

      if (response.data.error !== 0) {
        showToast("error", response.data.message);
      } else {
        getUserTransaction();
        setUpdateBalance(!updateBalance);
        // document.querySelectorAll('.reset').forEach(btn => btn.click());
        showToast("success", response.data.message);
        // document.getElementById('trade')?.click();
      }
    } catch (error) {
      // setData(prev => ({ ...prev, loader: false }));

      if (error.response?.data?.error === "invalid_token") {
        showToast("error", "Session Timeout. Login Again");
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const getUserTransaction = async () => {
    setLoader(true);

    let userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    const selectedMarginType = localStorage.getItem("selectedMarginType");
    if (selectedMarginType) {
      userTransObj.marginType = selectedMarginType;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      const balanceList = result.userBalanceList || [];

      if (balanceList.length > 0) {
        localStorage.setItem(
          "usdbalance",
          balanceList.find((item) => item.currencyCode === "USD")
            ?.closingBalance || 0
        );
      }

      if (result.error?.error_data !== 0) {
        showToast("error", "Cannot fetch user balance");
      } else {
        const buyingCrypto = localStorage
          .getItem("buying_crypto_asset")
          ?.toUpperCase();
        const sellingCrypto = localStorage
          .getItem("selling_crypto_asset")
          ?.toUpperCase();
        const pricePrecision = localStorage.getItem("priceprc") || 2;

        let selectedBuyingAssetBalance = null;
        let selectedSellingAssetBalance = null;

        balanceList.forEach((balance) => {
          if (balance.currencyCode === buyingCrypto) {
            selectedBuyingAssetBalance =
              balance.closingBalance.toFixed(pricePrecision);
          }
          if (balance.currencyCode === sellingCrypto) {
            selectedSellingAssetBalance =
              balance.closingBalance.toFixed(pricePrecision);
          }
        });

        setBalances({
          balanceList,
          selectedBuyingAssetBalance,
          selectedSellingAssetBalance,
        });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "Session Timeout. Login Again");
        //logout
      }
    } finally {
      setLoader(false);
    }
  };

  const handleCloseButton = (param, content) => {
    setSelectedCounterBuySellTxn(param);

    if (param.action.toUpperCase() === "BUY") {
      setSelectedCounterType("Buy");
    } else {
      setSelectedCounterType("Sell");
    }

    setShowTradeClose(true);
  };

  const handleConfirmCloseButton = () => {
    let param = selectedCounterBuySellTxn;
    let txnSide = "";
    let marginType = 2;

    if (param.action.toUpperCase() === "BUY") {
      txnSide = "BID";
    } else {
      txnSide = "ASK";
    }

    if (param.offer_type === 5) {
      marginType = "1";
    } else if (param.offer_type === 6) {
      marginType = "2";
    }

    const inputObj = {
      selling_asset_code: param.buying_asset_code.toUpperCase(),
      buying_asset_code: param.selling_asset_code.toUpperCase(),
      amount: parseFloat(param.amount),
      price: selectedCounterBuySellTxn.price,
      offerType: "P",
      txn_type: param.action.toUpperCase() === "BUY" ? "2" : "1",
      assetCode: param.assetcode,
      portfolioId: param.mpTransactionId,
      marginType: marginType,
      assetPair: param.asset_pair,
      leverage: param.leverage,
      uuid: localStorage.getItem("uuid"),
    };

    if (
      parseFloat(selectedCounterBuySellTxn.price) * parseFloat(param.amount) >=
      0.001
    ) {
      axios
        .post(`${WEBSERVICE}optionsTrade/TradeCreateOffer`, inputObj, {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          const result = response.data;

          if (result.error.error_data !== 0) {
            showToast("error", result.error.error_msg);
          } else {
            showToast("success", result.error.error_msg);
            renderDataForMyTradeSpot();
            setUpdateBalance(!updateBalance);
            handleTradeClose();
          }
        })
        .catch((error) => {
          // showToast("error", "An error occurred");
        });
    } else {
      showToast("warning", "Offer Value is lesser than permissible value");
    }
  };

  const getSpecificCurrencyPrecision = (param) => {
    let list = precision_list_json;
    let precision = 0;
    for (let i = 0; i < list.length; i++) {
      if (
        list[i].CURRENCYID == param ||
        list[i].CURRENCY == param.toUpperCase()
      ) {
        precision = list[i].PRECISION;
        break;
      }
    }
    return precision;
  };

  const handletabchange = (value) => {
    setTabKey(value);
  };

  const delOffer = async () => {
    try {
      let inputObj = {
        offer_id: delOfferId,
        amount: "0",
        txn_type: delTxnType,
        price: delPrice,
        offerType: "L",
        leverage: delLaverage,
        uuid: localStorage.getItem("uuid"),
      };

      if (delTxnType === 2) {
        inputObj.selling_asset_code = currencycode?.toUpperCase();
        inputObj.buying_asset_code = basecurrency?.toUpperCase();
        inputObj.assetPair = assetpair;
      }

      if (delTxnType === 1) {
        inputObj.selling_asset_code = basecurrency?.toUpperCase();
        inputObj.buying_asset_code = currencycode?.toUpperCase();
        inputObj.assetPair = assetpair;
      }

      if (parseInt(delLaverage) > 1) {
        inputObj.marginType = delMarginType;
      }

      const response = await axios.post(
        `${WEBSERVICE}optionsTrade/TradeManageOffer`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("warning", response.data.error.error_msg);
      } else {
        renderDataForMyOfferSpot();
        setUpdateBalance(!updateBalance);
        getUserTransaction();
        handleCloseDeleteOpen();

        showToast("success", response.data.error.error_msg);
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const getStoplossPrice = (s) => {
    return parseFloat(
      s.stopLossPrice ? s?.stopLossPrice : s?.stop_loss_price
    ).toFixed(parseInt(tradep));
  };
  const getStoplossTriggerPrice = (s) => {
    return parseFloat(
      s.triggerPrice ? s?.triggerPrice : s?.trigger_price
    ).toFixed(parseInt(tradep));
  };
  const handleOpenFeeModal = () => {
    setShowFeesInfo(true);
  };

  const getFeesData = async () => {
    try {
      const accessToken = localStorage.getItem("access_token");
      const uuid = localStorage.getItem("uuid");

      const fundingResponse = await axios.get(
        `${WEBSERVICE}fMargin/fundingHomeView`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      setExchangeFees(fundingResponse.data.P_FUNDING_CURRENCY);

      const tradingFeesResponse = await axios.get(
        `${WEBSERVICE}optionsTrade/userWiseTradingFees?uuid=${uuid}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const res = tradingFeesResponse.data;
      if (res.userTradingFees && res.userTradingFees.length > 0) {
        setUserExchangeFee({
          totalVolume: parseFloat(res.userTradingFees[0].totalVolume).toFixed(
            2
          ),
          totalFees: parseFloat(res.userTradingFees[0].totalFees).toFixed(2),
          totalIntAccrued: parseFloat(
            res.userTradingFees[0].totalIntAccrued
          ).toFixed(2),
          totalIntEarned: res.userTradingFees[0].totalIntEarned,
        });
      } else {
        setUserExchangeFee({
          totalVolume: 0,
          totalFees: 0,
          totalIntAccrued: 0,
          totalIntEarned: 0,
        });
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    } finally {
      // document.body.classList.remove("overlay");
    }
  };

  return (
    <div>
      {/* ── Tab bar ── */}
      <div className="bt-tabbar">
        <div className="bt-tabs">
          <button
            className={`bt-tab ${activeTab === "hist" ? "active-bt" : ""}`}
            style={activeTab === "hist" ? { "--btn-color": btncolor } : {}}
            onClick={() => { handleAllButtonClickForMyTrades(); saveLastTabTradeComp("hist"); }}
          >
            MY TRADES
          </button>
          <button
            className={`bt-tab ${activeTab === "open" ? "active-bt" : ""}`}
            style={activeTab === "open" ? { "--btn-color": btncolor } : {}}
            onClick={() => { renderDataForMyOfferSpot(); saveLastTabTradeComp("open"); }}
          >
            LIMIT ORDERS
          </button>
          <button
            className={`bt-tab ${activeTab === "stop" ? "active-bt" : ""}`}
            style={activeTab === "stop" ? { "--btn-color": btncolor } : {}}
            onClick={() => {
              callAllStopLimitOffers();
              saveLastTabTradeComp("stop");
              setMyTradeTableAllPairs(false);
              setMyOfferTableAllPairs(false);
            }}
          >
            STOP-LIMIT ORDERS
          </button>
        </div>
        <button
          className="bt-fees-btn"
          style={{ background: btncolor }}
          onClick={() => handleOpenFeeModal()}
        >
          FEES
        </button>
      </div>

      {/* ── Filter row ── */}
      <div className="bt-filter-row">
        <div className="bt-filter-left">
          <ActionButton
            options={[
              { label: "ALL", value: "ALL" },
              { label: "BUY", value: "BUY" },
              { label: "SELL", value: "SELL" },
            ]}
            active={activeButton}
            onChange={handleButtonClick}
            btnColor={btncolor}
          />
          <InfoIcon
            style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
            onClick={() => setShow(true)}
          />
        </div>
        <div className="bt-filter-right">
          {activeTab === "hist" && (
            <>
              <input type="checkbox" onClick={handleCheckboxChange} />
              <label style={{ paddingLeft: "5px" }}>Show all pairs</label>
            </>
          )}
          {activeTab === "open" && (
            <>
              <input type="checkbox" onClick={checkValueMyOffer} />
              <label style={{ paddingLeft: "5px" }}>Show all pairs</label>
            </>
          )}
        </div>
      </div>

      {activeTab === "hist" && (
        <div className="bottom_table_modern">
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Contract</th>
                <th>Offer Type</th>
                <th>Amount</th>
                <th>Entry Price</th>
                <th>Mark Price</th>
                <th>Liq. Price</th>
                <th>PNL $(%)</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
            {spotMyTradeData?.length !== 0 ? (
              spotMyTradeData?.map(
                (m, index) =>
                  (activeButton === "ALL"
                    ? true
                    : m?.action?.toUpperCase() === activeButton) && (
                    <tr key={index}>
                      <td style={{ border: "none" }}>
                        {dateFormat(m?.transactionTimeStamp)}
                      </td>

                      <td style={{ border: "none" }}>
                        {m?.asset_pair}{" "}
                        <small
                          style={{
                            marginLeft: "5px",
                            backgroundColor: "#616F8D",
                            color: "#fff",
                            padding: "3px",
                            borderRadius: "5px",
                          }}
                        >
                          {m?.leverage}X
                        </small>
                      </td>

                      <td>
                        {m.offer_type === "5"
                          ? "ISO"
                          : m.offer_type === "6"
                          ? "CROSS"
                          : m.offer_type === "2"
                          ? "NO LEV"
                          : "OPTIONS"}
                      </td>
                      <td
                        style={{
                          color:
                            m.action === "buy"
                              ? "rgb(33, 203, 128)"
                              : "rgb(245, 71, 93)",
                        }}
                      >
                        {getTradeAmount(m)}{" "}
                        {m.action === "buy"
                          ? m.buying_asset_code
                          : m.selling_asset_code}
                      </td>
                      <td>{Number(m.price).toFixed(2)}</td>
                      <td>{Number(m.markPrice).toFixed(2)}</td>
                      <td>
                        {getLiqPrice(m) ? Number(m.liqPrice).toFixed(2) : "-"}
                      </td>
                      <td
                        style={{
                          color: handlePnlPositiveValue(m.pnl)
                            ? "rgb(33, 203, 128)"
                            : "rgb(245, 71, 93)",
                        }}
                      >
                        {m.pnl}
                      </td>
                      <td>
                        {(myTradeTableAllPairs ||
                          (m.leverage > 1 &&
                            m.mpTransactionId !== 0 &&
                            m.mpTransactionId !== null)) && (
                          <button
                            className="allbtn active"
                            style={{ color: "white" }}
                            onClick={() =>
                              handleCloseButton(m, "buyofferForFuture")
                            }
                          >
                            Close
                          </button>
                        )}
                      </td>
                    </tr>
                  )
              )
            ) : (
              <tr>
                <td colSpan={7} className="text-center text-danger">
                  No Data
                </td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === "open" && (
        <div className="bottom_table_modern">
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Offer Id</th>
                <th>Amount</th>
                <th>Price</th>
                <th>Total Value</th>
                <th>Offer Type</th>
                <th>Lev</th>
                <th>Buy-Sell</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
            {tradeOfferById?.length !== 0 ? (
              tradeOfferById?.map(
                (m, index) =>
                  (activeButton === "ALL"
                    ? true
                    : (m.txn_type === 1 && activeButton === "BUY") ||
                      (m.txn_type === 2 && activeButton === "SELL")) && (
                    <tr key={index}>
                      <td style={{ border: "none" }}>
                        {dateFormat(m?.transactionTimeStamp)}
                      </td>
                      <td>{m.offer_id}</td>
                      <td>{getTradeAmount(m)}</td>
                      <td>{getTradePrice(m)}</td>
                      <td>
                        {(getTradeAmount(m) * getTradePrice(m)).toFixed(
                          selectedBaseCurrencyPrecision
                        )}
                      </td>
                      <td>
                        {m.offer_type === "5"
                          ? "ISO"
                          : m.offer_type === "6"
                          ? "CROSS"
                          : m.offer_type === "2"
                          ? "NO LEV"
                          : "OPTIONS"}
                      </td>
                      <td>{m.leverage}X</td>
                      <td
                        className={
                          m.txn_type === 1 ? "text-success" : "text-danger"
                        }
                      >
                        {m.txn_type === 1 ? "Buy" : "Sell"}
                      </td>
                      <td>
                        <button
                          className="allbtn active"
                          style={{ color: "white" }}
                          onClick={() =>
                            m.offer_type === "0"
                              ? getOfferDetails("modify", m.offer_id)
                              : getMarginOfferDetails("modify_m", m.offer_id)
                          }
                        >
                          Modify
                        </button>
                      </td>
                      <td>
                        <button
                          className="allbtn active"
                          style={{ color: "white" }}
                          onClick={() =>
                            deleteTrade(
                              m.offer_type === "0" ? "delete" : "delete_m",
                              m.offer_id,
                              m.txn_type,
                              m.asset_pair,
                              m.price,
                              m.amount,
                              m.marginType,
                              m.leverage
                            )
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  )
              )
            ) : (
              <tr>
                <td colSpan={7} className="text-center text-danger">
                  No Data
                </td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === "stop" && (
        <div className="bottom_table_modern">
          <table>
            <thead>
              <tr>
                <th>Time stamp</th>
                <th>Order ID</th>
                <th>Asset pair</th>
                <th>Quantity</th>
                <th>Stop price</th>
                <th>Limit price</th>
                <th>Action</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
            {buyDataNew?.length !== 0 ? (
              buyDataNew?.map(
                (s, index) =>
                  (activeButton === "ALL"
                    ? true
                    : s?.type?.toUpperCase() === activeButton ||
                      (activeButton === "BUY" && s.action === 1) ||
                      (activeButton === "SELL" && s.action !== 1)) && (
                    <tr key={index}>
                      <td style={{ border: "none" }}>
                        {s?.timeStamp
                          ? dateFormat(s?.timeStamp)
                          : dateFormat(s?.transactionTimeStamp)}
                      </td>
                      <td>{s.stopLossId ? s?.stopLossId : s?.offer_id}</td>
                      <td>{s.assetPair}</td>
                      <td>{s.quantity}</td>
                      <td>{getStoplossTriggerPrice(s)}</td>
                      <td>{getStoplossPrice(s)}</td>
                      <td
                        className={
                          s.action === 1 || s?.type === "Buy"
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {s.action === 1 || s?.type === "Buy" ? "Buy" : "Sell"}
                      </td>
                      <td>
                        {s.stoplossType === "M" ? (
                          <button
                            onClick={() =>
                              marginModifyStoploss(
                                s.stopLossId,
                                s.quantity,
                                s.stopLossPrice,
                                s.triggerPrice,
                                s.tradePrice,
                                s.action
                              )
                            }
                            className="allbtn active"
                            style={{ color: "white" }}
                          >
                            Modify
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              modifyStoploss(
                                s.stopLossId,
                                s.quantity,
                                s.stopLossPrice,
                                s.triggerPrice,
                                s.action,
                                s.assetPair
                              )
                            }
                            className="allbtn active"
                            style={{ color: "white" }}
                          >
                            Modify
                          </button>
                        )}
                      </td>
                      <td>
                        {s.stoplossType !== "M" ? (
                          <button
                            className="allbtn active"
                            style={{ color: "white" }}
                            onClick={() =>
                              delStoploss(
                                s.stopLossId,
                                s.quantity,
                                s.stopLossPrice,
                                s.triggerPrice,
                                s.action,
                                s.assetPair
                              )
                            }
                          >
                            Delete
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  )
              )
            ) : (
              <tr>
                <td colSpan={7} className="text-center text-danger">
                  No Data
                </td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      )}

      <ModalContent
        open={showTradeClose}
        onClose={handleTradeClose}
        title={`Buy Offer`}
        width="xs"
      >
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          Are you sure you want to close this position?
        </Typography>
        <Box className="d-flex justify-content-center align-items-center mt-2 gap-2">
          <OutlinedButton variant="outlined" onClick={handleTradeClose}>
            No
          </OutlinedButton>
          <ContainedButton onClick={handleConfirmCloseButton}>
            Yes
          </ContainedButton>
        </Box>
      </ModalContent>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={currentContent?.title}
        description={currentContent?.description}
      />

      <InfoPopUp
        open={showFees}
        onClose={handleCloseFees}
        title={"FEES"}
        description={`Check current Maker Fees, Taker Fees, and your Total trading
              volume.`}
      />

      <ModalContent
        open={showModify}
        onClose={handleCloseModify}
        title={`Manage Offer`}
        width="xs"
      >
        <ActionButton
          options={[
            { label: "Amount Update", value: "amountUpdate" },
            { label: "Price Update", value: "priceUpdate" },
          ]}
          active={tabKey}
          onChange={handletabchange}
          btnColor={btncolor}
        />

        {tabKey === "amountUpdate" && (
          <Form>
            <Form.Group>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                className="input-active"
                value={tabModifyAmount}
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setTabModifyAmount(parseFloat(e.target.value) || 0)
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                value={tabModifyPrice}
                readOnly
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Total Volumn</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                value={(tabModifyAmount * tabModifyPrice).toFixed(tradep)}
                readOnly
              />
            </Form.Group>
          </Form>
        )}

        {tabKey === "priceUpdate" && (
          <Form>
            <Form.Group>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                readOnly
                value={tabModifyAmount}
                onWheel={(e) => e.target.blur()}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                className="input-active"
                value={tabModifyPrice}
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setTabModifyPrice(parseFloat(e.target.value) || 0)
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Total Volumn</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                value={(tabModifyAmount * tabModifyPrice).toFixed(tradep)}
                readOnly
              />
            </Form.Group>
          </Form>
        )}

        <Box className="d-flex justify-content-center align-items-center gap-2 mt-3">
          <OutlinedButton variant="outlined" onClick={handleCloseModify}>
            Cancel
          </OutlinedButton>
          {tabKey === "amountUpdate" ? (
            <ContainedButton onClick={manageOfferAmount}>
              Submit
            </ContainedButton>
          ) : (
            <ContainedButton onClick={manageOfferPrice}>Submit</ContainedButton>
          )}
        </Box>
      </ModalContent>

      <ModalContent
        open={showDeleteOpen}
        onClose={handleCloseDeleteOpen}
        title={`Delete Offer`}
        width="xs"
      >
        <p class="text-center">Are you sure you want to delete this offer?</p>
        <Box className="d-flex justify-content-center align-items-center mt-3 gap-2">
          <OutlinedButton variant="outlined" onClick={handleCloseDeleteOpen}>
            No
          </OutlinedButton>
          <ContainedButton onClick={delOffer}>Yes</ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={showDelete}
        onClose={handleCloseDelete}
        title={`Delete Stop-limit`}
        width="xs"
      >
        <p class="text-center">Are you sure want to delete this stop-limit?</p>

        <Box className="d-flex justify-content-center align-items-center mt-3 gap-2">
          <OutlinedButton variant="outlined" onClick={handleCloseDelete}>
            No
          </OutlinedButton>
          <ContainedButton onClick={removeStoploss}>Yes</ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={showModifyStop}
        onClose={handleCloseModifyStop}
        title={`Manage Stop-limit`}
        width="xs"
      >
        <Form>
          <Form.Group>
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              value={modifySlAmount}
              className="input-active"
              onWheel={(e) => e.target.blur()}
              onChange={(e) => setModifySlAmount(e.target.value)}
              min={tradem}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Stop Price</Form.Label>
            <Form.Control
              type="number"
              value={modifySlTrigger}
              className="input-active"
              onWheel={(e) => e.target.blur()}
              onChange={(e) => setModifySlTrigger(e.target.value)}
              min={tradep}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Limit Price</Form.Label>
            <Form.Control
              type="number"
              value={modifySlPrice}
              className="input-active"
              onWheel={(e) => e.target.blur()}
              onChange={(e) => setModifySlPrice(e.target.value)}
              min={tradep}
            />
          </Form.Group>
        </Form>
        <Box className="d-flex justify-content-center align-items-center mt-3 gap-2">
          <OutlinedButton variant="outlined" onClick={handleCloseModifyStop}>
            Cancel
          </OutlinedButton>
          <ContainedButton
            onClick={() => {
              manageStoploss();
              handleCloseModifyStop();
            }}
          >
            Submit
          </ContainedButton>
        </Box>
      </ModalContent>

      <FeeModalFutureOption
        open={showFeesInfo}
        onClose={handleCloseFeesInfo}
        flag={false}
      />
    </div>
  );
};

export default OptionBottomTable;
